import * as React from 'react';
import { Fragment } from 'react';
import { makeStyles } from 'tss-react/mui';
import { required, minLength, maxLength, minValue, maxValue, number, regex, email, choices, Form, useResourceContext, useNotify } from 'react-admin';
import {
  useListContext,
  useRedirect,
  List,
  Datagrid,
  Filter,
  Edit,
  Create,

  Toolbar,
  TopToolbar,
  DeleteWithConfirmButton,
  BulkDeleteWithConfirmButton,
  Show,
  SimpleShowLayout,

  ReferenceField,
  TextField,
  ImageField,
  BooleanField,

  SimpleForm,
  ReferenceInput,
  SelectInput,
  TextInput,
  NumberInput,
  BooleanInput,
  NullableBooleanInput,

  Button,
  EditButton,
  ShowButton,
  SaveButton,
} from 'react-admin';
import { useForm, useFormContext } from 'react-hook-form';
import { Button as MButton, Box, useMediaQuery, Stack } from '@mui/material';
import { PreviewImage, UpLoadFile } from './custom/UpLoadFile';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SearchIcon from '@mui/icons-material/Search';
import ClearAllIcon from '@mui/icons-material/ClearAll';
//import ResetOrderNum from './Supplier_ResetOrderNum';

{/* 
  import { SupplierList, SupplierCreate, SupplierEdit, SupplierShow } from './components/Supplier';

  <Resource name="CMSSupplier" list={SupplierList} create={SupplierCreate} edit={SupplierEdit} show={SupplierShow} />
  <Resource name="CMSSupplier" list={ListGuesser} create={EditGuesser} edit={EditGuesser} edit={ShowGuesser} /> 
*/}

const useStyles = makeStyles()((theme) => {
  return {
    imageField: {
      '& img.RaImageField-image': { width: 60 }
    },
  };
});


const useTxtData = {
  page: {
    tableName: 'Supplier',
  },
  table: {
    id: 'id',
    S_Name: 'S_Name',
    S_Remarks: 'S_Remarks',
    S_Address: 'S_Address',
    S_Email: 'S_Email',
    S_Phone: 'S_Phone',
    S_Account: 'S_Account',
    S_Pwd: 'S_Pwd',
    S_PrepaidMoney: 'S_PrepaidMoney',
    S_lockingMoney: 'S_lockingMoney',
    S_SettlementMoney: 'S_SettlementMoney',
    S_ReminderMoney: 'S_ReminderMoney',
    S_DeliveryAddress: 'S_DeliveryAddress',
    S_CountryId: 'S_CountryId',
    S_DaysAhead: 'S_DaysAhead',
    S_PriceXZ: 'S_PriceXZ',
    S_PriceYE: 'S_PriceYE',
    OrderNum: 'OrderNum',
    S_LoginTime: 'S_LoginTime',
    S_ContactName: 'S_ContactName',
    CompanyInformation: 'CompanyInformation',
    BankInformation: 'BankInformation',
    Contract: 'Contract',
    A: 'A',
    B: 'B',
    C: 'C',
    D: 'D',
    E: 'E',
  }
};

//分页列表页面
export const SupplierList = () => {
  const redirect = useRedirect();//奇怪问题：这句必须保留，去掉后下面Filters里的setFilters({}, displayedFilters);会失效
  const isSmall = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));
  // 筛选器模块
  // const Filters = () => {
  //   return (
  //     <Filter>
  //       <TextInput label="ID" source="id" alwaysOn />
  //     </Filter>
  //   );
  // };
  const MobileFilters = [
    <TextInput label="关键词" source="Key" alwaysOn resettable />
  ];
  const Filters = (props: any) => {
    const { displayedFilters, filterValues, setFilters, hideFilter, refetch } = useListContext();
    if (isSmall) return null;
    if (props.context === "button") return null;
    const onSubmit = (values: any) => { if (Object.keys(values).length > 0) { setFilters(values, displayedFilters); } else { setFilters({}, displayedFilters); } };
    const resetFilter = () => { setFilters({}, displayedFilters); };
    return (
      <div>
        <Form onSubmit={onSubmit} defaultValues={filterValues}>
          <Stack direction={'row'} alignItems={'baseline'} spacing={1.5}>
            <TextInput label="关键词" source="Key" alwaysOn resettable />
            <MButton variant="contained" color="primary" type="submit" startIcon={<SearchIcon />}>搜索</MButton>
            <MButton variant="outlined" onClick={resetFilter} startIcon={<ClearAllIcon />}>重置</MButton>
          </Stack>
        </Form>
      </div>
    );
  };

  //批量操作模块
  const PostBulkActionButtons = () => {
    return (
      <Fragment>
        {/* <ResetOrderNum label="重置排序"  /> */}
        {/* <BulkDeleteWithConfirmButton confirmTitle="删除确认" confirmContent="确认要删除所选记录吗？" mutationMode='undoable' /> */}
      </Fragment>
    );
  };
  //行右侧功能按钮
  const RowAction = () => {
    return (
      <div style={{ textAlign: 'right' }}>
        <EditButton /><br />
        <ShowButton /><br />
        <DeleteWithConfirmButton confirmTitle="删除确认" confirmContent="确认要删除该记录吗？" />
      </div>
    );
  }

  const { classes } = useStyles();
  return (
    <List
      title={useTxtData.page.tableName + '列表'}
      sort={{ field: 'id', order: 'DESC' }}
      filters={<Filters />}
      exporter={false}
      sx={{ "& .MuiToolbar-root .MuiToolbar-root": { height: 0, minHeight: 0 } }}
    >
      <Datagrid
        // bulkActionButtons={<PostBulkActionButtons />}
        bulkActionButtons={false}
      >
        {/* <TextField source="id" /> */}
        {/* <TextField label="名称" source="Name" /> */}
        {/* <TextField label="排序" source="OrderNum" />  */}
        <TextField label={useTxtData.table.id} source="id" />
        <TextField label={useTxtData.table.S_Name} source="S_Name" />
        <TextField label={useTxtData.table.S_Remarks} source="S_Remarks" />
        <TextField label={useTxtData.table.S_Address} source="S_Address" />
        <TextField label={useTxtData.table.S_Email} source="S_Email" />
        <TextField label={useTxtData.table.S_Phone} source="S_Phone" />
        <TextField label={useTxtData.table.S_Account} source="S_Account" />
        <TextField label={useTxtData.table.S_Pwd} source="S_Pwd" />
        <TextField label={useTxtData.table.S_PrepaidMoney} source="S_PrepaidMoney" />
        <TextField label={useTxtData.table.S_lockingMoney} source="S_lockingMoney" />
        <TextField label={useTxtData.table.S_SettlementMoney} source="S_SettlementMoney" />
        <TextField label={useTxtData.table.S_ReminderMoney} source="S_ReminderMoney" />
        <TextField label={useTxtData.table.S_DeliveryAddress} source="S_DeliveryAddress" />
        <TextField label={useTxtData.table.S_CountryId} source="S_CountryId" />
        <TextField label={useTxtData.table.S_DaysAhead} source="S_DaysAhead" />
        <TextField label={useTxtData.table.S_PriceXZ} source="S_PriceXZ" />
        <TextField label={useTxtData.table.S_PriceYE} source="S_PriceYE" />
        <TextField label={useTxtData.table.OrderNum} source="OrderNum" />
        <TextField label={useTxtData.table.S_LoginTime} source="S_LoginTime" />
        <TextField label={useTxtData.table.S_ContactName} source="S_ContactName" />
        <TextField label={useTxtData.table.CompanyInformation} source="CompanyInformation" />
        <TextField label={useTxtData.table.BankInformation} source="BankInformation" />
        <TextField label={useTxtData.table.Contract} source="Contract" />
        <TextField label={useTxtData.table.A} source="A" />
        <TextField label={useTxtData.table.B} source="B" />
        <TextField label={useTxtData.table.C} source="C" />
        <TextField label={useTxtData.table.D} source="D" />
        <TextField label={useTxtData.table.E} source="E" />
        <RowAction />
      </Datagrid>
    </List>
  );
};

////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////

//SHOW页面
export const SupplierShow = () => {
  const ShowActions = () => {
    const resource = useResourceContext();
    const redirect = useRedirect();
    return (
      <TopToolbar>
        <Button label="返回列表" onClick={() => redirect(`/${resource}`)} variant="text">
          <ArrowBackIcon />
        </Button>
        <EditButton />
      </TopToolbar>
    );
  };

  const { classes } = useStyles();
  return (
    <Show title={'查看' + useTxtData.page.tableName} actions={<ShowActions />}>
      <SimpleShowLayout>
        {/* <TextField source="id" /> */}
        {/* <TextField label="名称" source="Name" /> */}
        {/* <TextField label="排序" source="OrderNum" />  */}
        <TextField label={useTxtData.table.id} source="id" />
        <TextField label={useTxtData.table.S_Name} source="S_Name" />
        <TextField label={useTxtData.table.S_Remarks} source="S_Remarks" />
        <TextField label={useTxtData.table.S_Address} source="S_Address" />
        <TextField label={useTxtData.table.S_Email} source="S_Email" />
        <TextField label={useTxtData.table.S_Phone} source="S_Phone" />
        <TextField label={useTxtData.table.S_Account} source="S_Account" />
        <TextField label={useTxtData.table.S_Pwd} source="S_Pwd" />
        <TextField label={useTxtData.table.S_PrepaidMoney} source="S_PrepaidMoney" />
        <TextField label={useTxtData.table.S_lockingMoney} source="S_lockingMoney" />
        <TextField label={useTxtData.table.S_SettlementMoney} source="S_SettlementMoney" />
        <TextField label={useTxtData.table.S_ReminderMoney} source="S_ReminderMoney" />
        <TextField label={useTxtData.table.S_DeliveryAddress} source="S_DeliveryAddress" />
        <TextField label={useTxtData.table.S_CountryId} source="S_CountryId" />
        <TextField label={useTxtData.table.S_DaysAhead} source="S_DaysAhead" />
        <TextField label={useTxtData.table.S_PriceXZ} source="S_PriceXZ" />
        <TextField label={useTxtData.table.S_PriceYE} source="S_PriceYE" />
        <TextField label={useTxtData.table.OrderNum} source="OrderNum" />
        <TextField label={useTxtData.table.S_LoginTime} source="S_LoginTime" />
        <TextField label={useTxtData.table.S_ContactName} source="S_ContactName" />
        <TextField label={useTxtData.table.CompanyInformation} source="CompanyInformation" />
        <TextField label={useTxtData.table.BankInformation} source="BankInformation" />
        <TextField label={useTxtData.table.Contract} source="Contract" />
        <TextField label={useTxtData.table.A} source="A" />
        <TextField label={useTxtData.table.B} source="B" />
        <TextField label={useTxtData.table.C} source="C" />
        <TextField label={useTxtData.table.D} source="D" />
        <TextField label={useTxtData.table.E} source="E" />
      </SimpleShowLayout>
    </Show>
  );
}

////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////

//编辑页面
export const SupplierEdit = () => {
  const resource = useResourceContext();
  const redirect = useRedirect();

  const PostEditActions = () => {
    return (
      <TopToolbar >
        <Button label="返回列表" onClick={() => redirect(`/${resource}`)} variant="text">
          <ArrowBackIcon />
        </Button>
      </TopToolbar>
    );
  };
  const PostEditToolbar = () => {
    return (
      <Toolbar >
        <SaveButton />
      </Toolbar>
    );
  };
  return (
    <Edit redirect={`/${resource}`} title={'编辑' + useTxtData.page.tableName} actions={<PostEditActions />}>
      <MyForm Edit={true} toolbar={<PostEditToolbar />} />
    </Edit>
  );
};

////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////

//创建页面
export const SupplierCreate = () => {
  const resource = useResourceContext();
  const redirect = useRedirect();
  const notify = useNotify();

  const PostCreateActions = () => {
    return (
      <TopToolbar>
        <Button label="返回列表" onClick={() => redirect(`/${resource}`)} variant="text" >
          <ArrowBackIcon />
        </Button>
      </TopToolbar>
    );
  };
  const PostCreateToolbar = () => {
    const { reset, resetField, handleSubmit, setValue, getValues, } = useFormContext();
    return (
      <Toolbar>
        <SaveButton alwaysEnable label="保存&列表" />
        <SaveButton alwaysEnable type='button' label="保存&继续" variant="text" mutationOptions={{
          onSuccess: () => {
            notify('创建成功', { type: 'success' });
            reset();
          }
        }} />
      </Toolbar>
    );
  };

  return (
    <Create redirect={`/${resource}`} title={'新增' + useTxtData.page.tableName} actions={<PostCreateActions />}>
      <MyForm Create={true} toolbar={<PostCreateToolbar />} />
    </Create>
  );
};

////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////
//Create和Edit公用表单
const MyForm = (props: any) => {
  let { Edit, Create } = props;
  return (
    <SimpleForm {...props} >
      {/* <TextInput source="Name" /> */}
      {/* <NumberInput source="OrderNum" /> */}
      <TextInput label={useTxtData.table.id} source="id" validate={[required()]} />
      <TextInput label={useTxtData.table.S_Name} source="S_Name" validate={[required()]} />
      <TextInput label={useTxtData.table.S_Remarks} source="S_Remarks" validate={[required()]} />
      <TextInput label={useTxtData.table.S_Address} source="S_Address" validate={[required()]} />
      <TextInput label={useTxtData.table.S_Email} source="S_Email" validate={[required()]} />
      <TextInput label={useTxtData.table.S_Phone} source="S_Phone" validate={[required()]} />
      <TextInput label={useTxtData.table.S_Account} source="S_Account" validate={[required()]} />
      <TextInput label={useTxtData.table.S_Pwd} source="S_Pwd" validate={[required()]} />
      <TextInput label={useTxtData.table.S_PrepaidMoney} source="S_PrepaidMoney" validate={[required()]} />
      <TextInput label={useTxtData.table.S_lockingMoney} source="S_lockingMoney" validate={[required()]} />
      <TextInput label={useTxtData.table.S_SettlementMoney} source="S_SettlementMoney" validate={[required()]} />
      <TextInput label={useTxtData.table.S_ReminderMoney} source="S_ReminderMoney" validate={[required()]} />
      <TextInput label={useTxtData.table.S_DeliveryAddress} source="S_DeliveryAddress" validate={[required()]} />
      <TextInput label={useTxtData.table.S_CountryId} source="S_CountryId" validate={[required()]} />
      <TextInput label={useTxtData.table.S_DaysAhead} source="S_DaysAhead" validate={[required()]} />
      <TextInput label={useTxtData.table.S_PriceXZ} source="S_PriceXZ" validate={[required()]} />
      <TextInput label={useTxtData.table.S_PriceYE} source="S_PriceYE" validate={[required()]} />
      <TextInput label={useTxtData.table.OrderNum} source="OrderNum" validate={[required()]} />
      <TextInput label={useTxtData.table.S_LoginTime} source="S_LoginTime" validate={[required()]} />
      <TextInput label={useTxtData.table.S_ContactName} source="S_ContactName" validate={[required()]} />
      <TextInput label={useTxtData.table.CompanyInformation} source="CompanyInformation" validate={[required()]} />
      <TextInput label={useTxtData.table.BankInformation} source="BankInformation" validate={[required()]} />
      <TextInput label={useTxtData.table.Contract} source="Contract" validate={[required()]} />
      <TextInput label={useTxtData.table.A} source="A" validate={[required()]} />
      <TextInput label={useTxtData.table.B} source="B" validate={[required()]} />
      <TextInput label={useTxtData.table.C} source="C" validate={[required()]} />
      <TextInput label={useTxtData.table.D} source="D" validate={[required()]} />
      <TextInput label={useTxtData.table.E} source="E" validate={[required()]} />
    </SimpleForm>
  );
}